/**
 * Message enum
 *
 * @export
 * @enum {string}
 *
 */
export var MessageEnum;
(function (MessageEnum) {
    MessageEnum["SUCCESS"] = "success";
    MessageEnum["ERROR"] = "error";
    MessageEnum["WARNING"] = "warning";
    MessageEnum["INFO"] = "info";
})(MessageEnum || (MessageEnum = {}));
//# sourceMappingURL=message.enum.js.map